const template = `
<div class="bottom-conditions">
	<form>
		<div class="conditions-container point-sums">
			<h2>%point-reduction-sum%</h2>
			<div class="conditions-inner" data-name="pointSums">
				<div class="rows">

					<div class="row" data-sticky-template="bottom-conditions-point-reduction-point-sum-row">
						<div class="button delete">
							<div class="wrapper">
								<div class="align y x"><div><div class="base-blue"></div></div></div>
								<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
							</div>
						</div>
						<label>%Min% <input type="number" inputmode="numeric" class="min-points" name="pointSums[%row%][minPoints]" min="-1" max="999"></label>
						<label class="mr-20">%max% <input type="number" inputmode="numeric" class="max-points" name="pointSums[%row%][maxPoints]" min="-1" max="999"> %in-point-sum%</label>
						<label class="mr-20">%in%
							<div class="styled-select">
								<select class="number-of-races" name="pointSums[%row%][numberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div> %of-races%</label>
						<div class="race-selector" data-input-name="pointSums[%row%][legNumbers][]"></div>
					</div><!-- ROW -->

				</div>

				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->
		<div class="conditions-container factor-on-point-sums">
			<h2>%point-reduction-factor%</h2>
			<div class="conditions-inner" data-name="factorOnPointSums">
				<div class="rows">

					<div class="row" data-sticky-template="bottom-conditions-point-reduction-factor-on-point-sum-row">
						<div class="button delete">
							<div class="wrapper">
								<div class="align y x"><div><div class="base-blue"></div></div></div>
								<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
							</div>
						</div>
						<label>%rows-with-point-sum% %from% <input type="number" inputmode="numeric" class="min-points" name="factorOnPointSums[%row%][minPoints]" min="-1" max="999"></label>
						<label class="mr-20">%to% <input type="number" inputmode="numeric" class="max-points" name="factorOnPointSums[%row%][maxPoints]" min="-1" max="999"> %points%</label>
						<label class="mr-20">%should-be-submitted% <input type="number" inputmode="numeric" class="factor" name="factorOnPointSums[%row%][factor]" min="1" max="99" disabled> %times%</label>
					</div><!-- ROW -->

				</div>

				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container winners-in-intervals">
			<h2>%point-reduction-number-winners%</h2>
			<div class="conditions-inner" data-name="winnersInIntervals">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-point-reduction-winners-in-interval-row">
						<div class="button delete">
							<div class="wrapper">
								<div class="align y x"><div><div class="base-blue"></div></div></div>
								<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
							</div>
						</div>
						<label>%From% <input type="number" inputmode="numeric" class="from-points" name="winnersInIntervals[%row%][fromPoints]" min="-1" max="255"></label>
						<label class="mr-20">%to% <input type="number" inputmode="numeric" class="to-points" name="winnersInIntervals[%row%][toPoints]" min="-1" max="255"> %points%</label>
						<label class="">%in-min%
							<div class="styled-select">
								<select class="number-of-races min-number-of-races" name="winnersInIntervals[%row%][minNumberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div>
						</label>
						<label class="mr-20">%max%
							<div class="styled-select">
								<select class="number-of-races max-number-of-races" name="winnersInIntervals[%row%][maxNumberOfRaces]"></select>
								<span class="sprite dropdown"></span>
							</div> %of-races%</label>
						<div class="race-selector" data-input-name="winnersInIntervals[%row%][legNumbers][]"></div>
					</div><!-- ROW -->
				</div>
				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->

		<div class="conditions-container misc">
			<h2>%point-reduction-miscellaneous%</h2>
			<div class="conditions-inner" data-name="misc">
				<div class="rows">
					<div class="row" data-sticky-template="bottom-conditions-point-reduction-misc-row">
						<div class="button delete">
							<div class="wrapper">
								<div class="align y x"><div><div class="base-blue"></div></div></div>
								<div class="align y x"><div class="content"><span class="sprite button-minus-small"></span></div></div>
							</div>
						</div>
						<div class="styled-select">
							<select class="misc-require-mode" name="misc[%row%][requireMode]"></select>
							<span class="sprite dropdown"></span>
						</div>
						<div class="styled-select">
							<select class="misc-type" name="misc[%row%][type]"></select>
							<span class="sprite dropdown"></span>
						</div>
						<label class="">%from% <input type="number" inputmode="numeric" class="from-points" name="misc[%row%][fromPoints]" min="-1" max="255"></label>
						<label class="mr-20">%to% <input type="number" inputmode="numeric" class="to-points" name="misc[%row%][toPoints]" min="-1" max="255"> %points-in-race%</label>
						<div class="race-selector" data-input-name="misc[%row%][legNumbers][]"></div>
					</div><!-- ROW -->
				</div>
				<div class="button plus">
					<div class="wrapper">
						<div class="align y x"><div><div class="base-blue"></div></div></div>
						<div class="align y x"><div class="content"><span class="sprite button-plus-small"></span></div></div>
					</div>
				</div>
			</div>
		</div><!-- CONTAINER -->

		<input type="submit" class="submit">
	</form>
</div>
`;

export default template;
